<template>
    <a-drawer :title="$t('hotel.service_item_configuration', { name: record.channel_name } /* 服务项目配置-{name} */)" :width="'80%'" :visible="visible" @close="onClose">
        <div class="order-box">
            <!--    搜索条件    -->
            <div class="table-page-search-wrapper">
                <a-form layout="inline" class="hidden">
                    <a-row :gutter="[10, 10]">
                        <a-col :xl="6" :xxl="3" :lg="8" :xs="12" style="text-align: left">
                            <a-form-item label="">
                                <a-input
                                    v-model="searchParams.tax_classification_code"
                                    :placeholder="$t('formConfig.please_enter' /* 请输入*/) + $t('hotel.tax_classification_code' /* 税收分类编码) */)"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :xl="6" :xxl="3" :lg="8" :xs="12" style="text-align: left">
                            <a-form-item label="">
                                <a-input v-model="searchParams.product_name" :placeholder="$t('hotel.enter_product_name' /* 请输入商品名称 */)" />
                            </a-form-item>
                        </a-col>
                        <a-col :xl="6" :xxl="3" :lg="8" :xs="12" style="text-align: left">
                            <a-form-item label="">
                                <a-input v-model="searchParams.tax_classification_name" :placeholder="$t('hotel.enter_tax_classification_name' /* 税收分类名称 */)" />
                            </a-form-item>
                        </a-col>

                        <a-col :xl="6" :xxl="3" :lg="8" :xs="12" style="text-align: left">
                            <a-form-item label="">
                                <a-input v-model="searchParams.metering_unit" :placeholder="$t('hotel.enter_metering_unit' /* 请输入计量单位 */)" />
                            </a-form-item>
                        </a-col>
                        <a-col :xl="6" :xxl="3" :lg="8" :xs="12" style="text-align: left">
                            <a-form-item label="">
                                <a-input v-model="searchParams.specification_model" :placeholder="$t('formConfig.please_enter' /* 请输入*/) + $t('hotel.specification_model' /* 规格型号) */)" />
                            </a-form-item>
                        </a-col>

                        <a-col :xl="6" :xxl="3" :lg="8" :xs="12" style="text-align: left">
                            <a-form-item label="" style="margin-bottom: 0">
                                <a-select v-model="searchParams.tax_rate_id" :placeholder="$t('hotel.select_tax_rate' /* 请选择税率*/)" style="width: 100%" allowClear>
                                    <a-select-option v-for="item in taxList" :key="item.id" :value="item.id">{{ item.store_name }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xl="6" :xxl="4" :lg="8" :xs="12" style="text-align: left">
                            <a-button type="primary" @click="handleSearch" style="">{{ $t('web.search' /* 搜索 */) }}</a-button>
                            <a-button
                                style="margin-left: 4px"
                                @click="
                                    () => {
                                        this.searchParams = {};
                                        this.pagination.page = 1;
                                        this.getDataList();
                                    }
                                "
                            >
                                {{ $t('layout.reset' /* 重置 */) }}
                            </a-button>
                            <a-button style="margin-left: 4px" @click="hanleAdd">{{ $t('web.new' /* 新增 */) }}</a-button>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-table ref="table" size="default" :rowKey="record => record.id" :columns="columns" :dataSource="dataList" :pagination="false" class="mt20" :scroll="{ x: 1800, y: 700 }">
                <span slot="real_name" slot-scope="text, recode">
                    <a-button type="link" @click="handlePreviewUser(recode)">
                        {{ text }}
                        <i v-if="recode.is_vip == 1" class="medcon med-huiyuanvip" style="color: #f4a52a"></i>
                    </a-button>
                </span>

                <span slot="name" slot-scope="text, recode">
                    <a href="javascript:;" @click="handleEdit(recode)">
                        {{ recode.order_no || $t('goods.temp_no' /* 暂无 */) }}
                    </a>
                </span>
                <span slot="action" slot-scope="text, recode">
                    <div class="flex">
                        <a-button type="link" @click="handleEdit(recode)">{{ $t('web.edit' /* 编辑 */) }}</a-button>
                        <a-button type="link" @click="handleDelete(recode)">{{ $t('web.delete' /* 删除 */) }}</a-button>
                    </div>
                </span>
            </a-table>
            <div class="t-r mt30">
                <a-pagination
                    :show-total="total => $t('web.pagination_total', { value: total } /* 共${total}条 */)"
                    show-size-changer
                    v-model="pagination.page"
                    :page-size="pagination.limit"
                    :total="paginationTotal"
                    @change="handlePaginationChangeEvent"
                    @showSizeChange="handlePaginationChangeEvent"
                />
            </div>
        </div>
        <add-commodity ref="addCommodity" :channel_id="record.channel_id" @ok="getDataList" />
    </a-drawer>
</template>
<script>
import addCommodity from './add-commodity.vue';
export default {
    components: { addCommodity },
    data() {
        return {
            form: this.$form.createForm(this),
            visible: false,
            searchParams: {},
            // 分页
            pagination: {
                page: 1,
                limit: 10
            },
            paginationTotal: 0,
            dataList: [],
            taxList: [],
            record: {},
            columns: [
                {
                    title: this.$t('web.index' /* 序号 */),
                    dataIndex: 'no',
                    align: 'center',
                    fixed: 'left',
                    width: 100
                },
                {
                    title: this.$t('hotel.product_name' /* 商品名称 */),
                    dataIndex: 'product_name',
                    align: 'center',
                    fixed: 'left',
                    width: 120
                    // scopedSlots: { customRender: "real_name" },
                },
                {
                    title: this.$t('hotel.tax_classification_code' /* 税收分类编码 */),
                    dataIndex: 'tax_classification_code',
                    align: 'center'
                },
                {
                    title: this.$t('hotel.tax_classification_name' /*税收分类名称 */),
                    dataIndex: 'tax_classification_name',
                    align: 'center'
                },
                {
                    title: this.$t('hotel.tax_simple_name' /* 税收分类简称 */),
                    dataIndex: 'short_name',
                    align: 'center'
                },
                {
                    title: this.$t('hotel.goods_no' /* 企业商品编号 */),
                    dataIndex: 'enterprise_commodity_code',
                    align: 'center'
                },
                {
                    title: this.$t('hotel.tax_rate' /* 税率 */),
                    dataIndex: 'front_name',
                    align: 'center',
                    width: 80
                },
                {
                    title: this.$t('formConfig.please_enter' /* 请输入*/) + this.$t('hotel.specification_model' /* 规格型号) */),
                    dataIndex: 'specification_model',
                    align: 'center'
                },
                {
                    title: this.$t('hotel.enter_metering_unit' /* 请输入计量单位 */),
                    dataIndex: 'metering_unit',
                    align: 'center'
                },
                {
                    title: this.$t('hotel.unit_price' /* 单价 */),
                    dataIndex: 'price',
                    align: 'center'
                },
                {
                    title: this.$t('web.actions' /* 操作 */),
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' },
                    align: 'center',
                    fixed: 'right',
                    width: 150
                }
            ]
        };
    },
    methods: {
        handleEdit(record) {
            this.$refs.addCommodity.show(record);
        },
        show(record) {
            this.searchParams = {};
            this.record = record;
            this.visible = true;
            this.getInvoiceTaxList(record.channel_id);
            this.getDataList();
        },
        onClose() {
            this.visible = false;
        },
        // 切换分页
        handlePaginationChangeEvent(page, limit) {
            this.pagination = {
                page,
                limit
            };
            this.getDataList();
        },
        hanleAdd() {
            this.$refs.addCommodity.show();
        },
        handleDelete(item) {
            this.$confirm({
                title: this.$t('web.tips' /* 提示 */),
                content: this.$t('web.confirm_delete_data' /* 确定删除该条数据吗？ */),
                okText: this.$t('web.ok' /* 确定 */),
                cancelText: this.$t('web.cancel' /* 取消 */),
                onOk: () => {
                    let data = {
                        channel_id: this.record.channel_id,
                        product_id: item.id
                    };
                    this.$request.post({ url: 'delInvoiceProduct', data }).then(res => {
                        if (res.code == 200) {
                            this.$message.success(this.$t('web.delete_success' /* 删除成功 */));
                            this.getDataList();
                        }
                    });
                }
            });
        },
        // 税率接口
        getInvoiceTaxList(channel_id) {
            let data = {
                channel_id
            };
            this.$request.get({ url: 'getInvoiceTaxList', data }).then(res => {
                this.taxList = res.data;
            });
        },
        // 获取表格数据
        getDataList() {
            let data = {
                channel_id: this.record.channel_id,
                ...this.pagination,
                ...this.searchParams
            };
            this.$request.get({ url: 'getInvoiceProductList', data }).then(res => {
                this.paginationTotal = res.data.totalCount;
                this.dataList = res.data.data;
            });
        },
        handleSearch() {
            this.pagination.page = 1;
            this.getDataList();
        }
    }
};
</script>
